import React from 'react';
import OptionallyDisplayed from './OptionallyDisplayed.js';
import PropTypes from 'prop-types';

export default class TextView extends React.Component {

  constructor(props) {
    super(props);
    this.shouldDisplayError = this.shouldDisplayError.bind(this);
  }

  shouldDisplayError() {
    return this.props.showError && this.props.errorText !== "";
  }

  render() {

    var cls = "input";
    cls += this.shouldDisplayError() ? ' input--error': '';
    if(this.props.className) {
      cls += ' ' + this.props.className;
    }
    
    var textCls = "form-field text-field";
    if(this.props.inline) {
      textCls += ' form-field--inline';
    }

    var errorCls = "validation-error";
    if(this.props.absoluteError) {
      errorCls += ' validation-error--absolute';
      textCls += ' form-field--relative'
    }

    return (
      <div className={textCls}>
        <input 
        className={cls}
        id={this.props.id}
        name={this.props.name}
        style={this.props.style}

        autoComplete={this.props.autoComplete}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        onClick={this.props.onClick}
        type={this.props.type || "text"}
        placeholder={this.props.placeholder}
        value={this.props.text}
        disabled={this.props.disabled}
        str={this.props.str}
        onChange={this.props.onFieldChanged}
        data-input={this.props.dataInput}
        onKeyPress={this.props.onKeyPress}
        />

        <OptionallyDisplayed display={this.shouldDisplayError()}>
          <div className={errorCls}>
            <span className="text">{this.props.errorText}</span>
          </div>
        </OptionallyDisplayed>
      </div>
    );
  }
}

TextView.propTypes = {
  showError: PropTypes.bool.isRequired,
  onFieldChanged: PropTypes.func.isRequired
};
